class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
  }

  onTabClick(event) {
    this.selectTab(event.currentTarget);
  }

  selectTab(selectedTab) {
    this.tabs.forEach(tab => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected);
      tab.setAttribute('tabindex', isSelected ? 0 : -1);
    });

    this.panels.forEach(panel => {
      const isForSelectedTab = panel.id === selectedTab.getAttribute('aria-controls');
      panel.hidden = !isForSelectedTab;
    });

    selectedTab.focus();
  }
}

customElements.define('product-tabs', ProductTabs);
